import React, {useEffect, useState} from 'react'
import './Market.scss'
import {useTranslation} from 'react-i18next';
import utils from "../../utils/utils.json"
import "../../request/RequestMarket";
import MarketTable from "../../containers/Table/MarketTable/MarketTable";
import {findTickerByName, getStocksList, getTrends} from "../../request/RequestMarket";
import {getFormatStocks} from "../../utils/services";
import routes from "../../utils/routes.json";
import {useNavigate} from "react-router-dom";
import InputResearch from "../../components/Input/InputResearch/InputResearch";
import TrendsTable from "../../containers/Table/TrendsTable/TrendsTable";
import Spinner from "../../components/Spinner/Spinner";
import constants from "../../utils/constants.js"
import TablePagination from "@mui/material/TablePagination";
import Skeleton from '@mui/material/Skeleton';

const TrendsSkeletonRow = () => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 16px', borderBottom: '1px solid #f1f5f9' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <Skeleton animation="wave" variant="circular" width={35} height={35} />
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Skeleton animation="wave" variant="text" width={50} height={20} />
                <Skeleton animation="wave" variant="text" width={90} height={16} />
            </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <Skeleton animation="wave" variant="text" width={50} height={20} sx={{ display: { xs: 'none', md: 'block' } }} />
            <Skeleton animation="wave" variant="rounded" width={85} height={32} sx={{ borderRadius: '8px' }} />
        </div>
    </div>
);

const MarketSkeletonRow = () => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid #f1f5f9' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flex: 1 }}>
            <Skeleton animation="wave" variant="circular" width={40} height={40} />
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Skeleton animation="wave" variant="text" width={50} height={24} />
                <Skeleton animation="wave" variant="text" width={110} height={16} />
            </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '30px', flex: 1, justifyContent: 'flex-end' }}>
            <Skeleton animation="wave" variant="text" width={60} height={20} sx={{ display: { xs: 'none', md: 'block' } }} />
            <Skeleton animation="wave" variant="text" width={50} height={20} sx={{ display: { xs: 'none', sm: 'block' } }} />
            <Skeleton animation="wave" variant="rounded" width={85} height={32} sx={{ borderRadius: '8px' }} />
        </div>
    </div>
);
function Market() {
    const {t} = useTranslation();
    const market_cols = utils.market_table
    const labelsToExclude = ["variation", "name", "changeAmount", "currency", "volume", "changePercentage"];
    const trends_cols = utils.gainers.filter(gainer => !labelsToExclude.includes(gainer.label));
    const [gainers, setGainers] = useState([]);
    const [loosers, setLoosers] = useState([]);
    const [data, setData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [page, setPage] = useState(0);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true)
    const [search, setSearch] = useState(undefined)

    const [isFetchingPage, setIsFetchingPage] = useState(false);

    useEffect(() => {
        fetchMarket();
        fetchTrends();
    }, []);

    useEffect(() => {
        handleChange(search)
    }, [page]);

    async function fetchMarket() {
        setIsFetchingPage(true);
        const result = await getStocksList(page + 1);
        if (result.data) {
            setData(await getFormatStocks(result.data.content));
            setTotalCount(result.data.page.totalElements);
        }
        setIsFetchingPage(false);
    }

    async function fetchTrends() {
        const gainers_result = await getTrends()
        if (gainers_result.data) {
            setGainers(await getFormatStocks(gainers_result.data.gainersJson));
            const loosers_result = await getTrends()
            setLoosers(await getFormatStocks(loosers_result.data.loosersJson));
            setIsLoading(false)
        }
    }

    function handleChange(value) {
        if (value && value.length > 1) {
            setSearch(value)
            setIsFetchingPage(true);
            findTickerByName(value, page + 1).then(async data => {
                setData(await getFormatStocks(data.data.content))
                setTotalCount(data.data.page.totalElements)
                setIsFetchingPage(false);
            })
        } else {
            setSearch(undefined)
            fetchMarket()
        }
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    function handleSubmit(event, value) {
    }

    const handleClickTicker = (ticker) => {
        navigate(`${routes.stock_nav}/${ticker}`)
    }


    return (
        <div className='containerPage'>
            <div className={"pageMarket"}>
                <div className={"trends"}>
                    <div className={"headerMarket"}>
                        <h1>
                            {t('market.trends')}
                        </h1>
                    </div>

                    <div className="d-flex containerTrends">
                        {
                            isLoading ?
                                <div className={"boxTrends"} style={{ padding: 0, overflow: 'hidden' }}>
                                    {[...Array(5)].map((_, i) => <TrendsSkeletonRow key={i} />)}
                                </div>
                                :
                                <div className={"boxTrends"}>
                                    <TrendsTable
                                        colorPrice={constants.green}
                                        keyInter={"market.gainers_table"}
                                        columns={trends_cols}
                                        data={gainers}
                                        sign={utils.plus}
                                        handleClickTicker={handleClickTicker}
                                    />
                                </div>

                        }
                        {
                            isLoading ?
                                <div className={"boxTrends"} style={{ padding: 0, overflow: 'hidden' }}>
                                    {[...Array(5)].map((_, i) => <TrendsSkeletonRow key={i} />)}
                                </div>
                                :
                                <div className={"boxTrends"}>
                                    <TrendsTable
                                        colorPrice={constants.red}
                                        keyInter={"market.gainers_table"}
                                        columns={trends_cols}
                                        data={loosers}
                                        sign={utils.minus}
                                        handleClickTicker={handleClickTicker}
                                    />
                                </div>
                        }


                    </div>
                </div>
                <div className={"market"}>
                    <div className={"headerMarket mb-2"} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
                        <h1 className={"mb-0"} style={{ margin: 0 }}>
                            {t('market.market')}
                        </h1>
                        <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
                            <InputResearch handleChange={handleChange} handleSubmit={handleSubmit} clearOnBlur={false}/>
                        </div>
                        <div className={"pagination-top"} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <TablePagination
                                rowsPerPageOptions={[]}
                                component="div"
                                count={totalCount}
                                rowsPerPage={utils.rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                sx={{ borderBottom: 'none' }}
                            />
                        </div>
                    </div>
                    {
                        isLoading || isFetchingPage ?
                            <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#fff', borderRadius: '15px', overflow: 'hidden', border: '1px solid #f1f5f9', marginTop: '10px' }}>
                                {[...Array(8)].map((_, i) => <MarketSkeletonRow key={i} />)}
                            </div>
                            : data.length === 0 ?
                                <div style={{ textAlign: 'center', padding: '60px 20px', color: '#64748b' }}>
                                    <div style={{ fontSize: '4rem', marginBottom: '16px', opacity: 0.5 }}>📭</div>
                                    <h3 style={{ fontFamily: 'Gabarito-Bold', color: '#0f172a', marginBottom: '8px' }}>Aucune action trouvée</h3>
                                    <p style={{ margin: 0 }}>Essayez de chercher un autre Ticker ou nom d'entreprise.</p>
                                </div>
                            :
                            <MarketTable
                                handleClickTicker={handleClickTicker}
                                columns={market_cols}
                                keyInter={"market.table"}
                                data={data}
                                totalCount={totalCount}
                                page={page}
                                rowsPerPage={utils.rowsPerPage}
                                pagination={true}
                                handleChangePage={handleChangePage}
                            />
                    }

                </div>
            </div>
        </div>
    )
}

export default Market